
// To display flyout menus on hover

// Getting the nav elements that have a flyout menu
const menuNavs = Array.from(document.getElementsByClassName("menu-item"));


menuNavs.forEach(nav => {

  // Getting the corresponding flyout menu for the respective nav element
  const checkID = nav.id;
  let flyoutID = "";
  let flyoutIndicatorID = "";

  switch (checkID) {
    case "desktop-nav-product":
      flyoutID = "product-flyout";
      flyoutIndicatorID = "flyout-indicator-products";
      break;
    case "desktop-nav-need":
      flyoutID = "need-flyout";
      flyoutIndicatorID = "flyout-indicator-need"
      break;
    case "desktop-nav-brand":
      flyoutID = "brand-flyout";
      flyoutIndicatorID = "flyout-indicator-brand"
      break;
    case "desktop-nav-resources":
      flyoutID = "resources-flyout";
      flyoutIndicatorID = "flyout-indicator-resources"
      break;
    default:
      flyoutID = "none";
  } 

  // Making sure it only tries to display flyout menus for nav elements that have a flyout menu
  if (flyoutID !== "none") {
    const flyout = document.getElementById(flyoutID);
    const flyoutIndicator = document.getElementById(flyoutIndicatorID);

    // Event listeners for when nav options are hovered over
    nav.addEventListener("mouseenter", () => {
      flyout.style.display = flyoutID === "resources-flyout" ? "flex" : "block";
      flyoutIndicator.style.display = "block";
    });

    nav.addEventListener("mouseleave", () => {
      flyout.style.display = "none";
      flyoutIndicator.style.display = "none";
    });

    flyout.addEventListener("mouseenter", () => {
      flyout.style.display = flyoutID === "resources-flyout" ? "flex" : "block";
      flyoutIndicator.style.display = "block";
    });
    
    flyout.addEventListener("mouseleave", () => {
      flyout.style.display = "none";
      flyoutIndicator.style.display = "none";
    });

  }
});


// Mobile Side navigation open and close functionality functionality

const sideNav = document.getElementById("mobile-side-nav");
const openNavButton = document.getElementById("mobile-nav-menu-button");
const closeNavButton = document.getElementById("close-nav-button");

openNavButton.addEventListener("click", () => {
  sideNav.style.width = "320px";
});

closeNavButton.addEventListener("click", () => {
  sideNav.style.width = "0";
});

document.getElementById("products-sidenav-link").addEventListener("click", function() {
  document.getElementById("product-arrow").classList.toggle("rotate-link-arrow");
  document.getElementById("product-sublinks").classList.toggle("side-nav-sublinks-display");
});

document.getElementById("need-sidenav-link").addEventListener("click", function() {
  document.getElementById("need-arrow").classList.toggle("rotate-link-arrow");
  document.getElementById("need-sublinks").classList.toggle("side-nav-sublinks-display");
});

document.getElementById("brand-sidenav-link").addEventListener("click", function() {
  document.getElementById("brand-arrow").classList.toggle("rotate-link-arrow");
  document.getElementById("brand-sublinks").classList.toggle("side-nav-sublinks-display");
});

document.getElementById("resources-sidenav-link").addEventListener("click", function() {
  document.getElementById("resources-arrow").classList.toggle("rotate-link-arrow");
  document.getElementById("resources-sublinks").classList.toggle("side-nav-sublinks-display");
});


//Show background color on mobile menu drawer so user knows which page they are on

document.addEventListener("DOMContentLoaded", function() {
  var currentPage = window.location.href;

  var sidenavLinks = document.querySelectorAll(".sidenav-links");

  sidenavLinks.forEach(function(link) {

    if (currentPage.includes("/home") && link.innerHTML.includes("Home")) {
      link.classList.add("mobile-nav-active");
    } 
    if (currentPage.includes("/products") && link.innerHTML.includes("Products")) {
      link.classList.add("mobile-nav-active");
    }
    if (currentPage.includes("/shop-by-need") && link.innerHTML.includes("Need")) {
      link.classList.add("mobile-nav-active");
    }
    if (currentPage.includes("/shop-by-brand") && link.innerHTML.includes("Brand")) {
      link.classList.add("mobile-nav-active");
    }
    if (currentPage.includes("/resources") && link.innerHTML.includes("Resources & FAQs")) {
      link.classList.add("mobile-nav-active");
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const searchForm = document.getElementById("header-search-form");
  const searchType = document.getElementById("search-option-select");

  searchType.addEventListener("change", (event) => {
    let searchOption = event.target.value;

    if (searchOption === "products") {
      searchForm.action = "https://shop.drivemedicalathome.com/search";
    } else {
      searchForm.action = "https://www.drivemedicalathome.com/hs-search-results";
    }            
  });

  // Code to make sure that the search type stays on content when searching for content
  document.addEventListener("DOMContentLoaded", () => {
    if (window.location.href.includes("https://www.drivemedicalathome.com/hs-search-results")) {
      searchType.value = "content";
    }
  });
});


